<template>
  <nav class="p-breadcrumb">
    <div v-for="(item, index) in items" :key="index" class="p-breadcrumb__item">
      <p-link
        v-if="index !== items.length - 1"
        :to="item.to"
        :label="item.label"
        size="md"
        class="f-utility-12-medium"
      />
      <div v-else class="p-breadcrumb__item--text f-utility-12-medium t-fg-tertiary">
        {{ item.label }}
      </div>
      <p-icon
        v-if="index !== items.length - 1"
        icon="caret-right"
        size="xsm"
        color="fg-secondary"
      />
    </div>
  </nav>
</template>

<script setup lang="ts">
interface BreadcrumbItem {
  label: string
  to: string
}

defineProps({
  items: {
    type: Array as () => BreadcrumbItem[],
    required: true,
  },
})
</script>
